module.exports = __webpack_public_path__ + "img/home-index-menu12.df8b5aa8.png";